const AddNoteRequest = function() {
  return {
    processId: "",
    category: null,
    description: null
  };
};

export default AddNoteRequest;



// WEBPACK FOOTER //
// ./src/service/request/AddNoteRequest.js